<template>
  <div class="segment-color-holder" :class="isMonochrome">
    <div
      ref="segmentColor"
      :class="getClass"
      :style="getColor"
      @click="handleSegmentColorClick">
      <svg class="sc-svg" fill="none" width="12" height="35" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" :fill="getPattern" fill-opacity=".7"/>
      </svg>
    </div>
    <ColorSelector :format="format" ref="selector" v-show="getShowSelector" :type="type" @color="setColor" />
  </div>
</template>

<script>
import ColorSelector from '@/components/nelson/ColorSelector';
import {useSegmentStore} from '@/store/SegmentStore';
import {useSettingsStore} from '@/store/SettingsStore';
export default {
  name: 'SegmentColor',
  components: { ColorSelector },
  props: [
    'segment',
    'show',
    'format',
    'type'
  ],
  data () {
    return {
      showSelector: false
    };
  },
  computed: {
    isMonochrome () {
      return (useSettingsStore().getIsMonochrome) ? 'monochrome' : '';
    },
    getPattern () {
      if (this.segment.pattern === undefined) { return; }
      const pattern = useSegmentStore().getPatternReferences[this.segment.pattern];
      if (pattern) { return pattern.url(); }
      return useSegmentStore().getPatternReferences[0].url();
    },
    getShowSelector () {
      return (this.$props.show) ? true : this.showSelector;
    },
    getColor () {
      return 'background-color : ' + 'transparent'; // + this.$props.segment.color;
    },
    getClass () {
      return (this.$props.format !== 'context') ? 'segment-color' : 'segment-color-context';
    }
  },
  methods: {
    handleSegmentColorClick () {
      this.showSelector = !this.showSelector;
/*      this.$refs.selector.$el.style.left = (this.$refs.segmentColor.getBoundingClientRect().left + 7) + 'px';*/
      document.body.addEventListener('mousedown', this.handleMouseDown);
    },
    handleMouseDown () {
      this.showSelector = false;
      document.body.removeEventListener('mousedown', this.handleMouseDown);
    },
    setColor (hex) {
      this.$props.segment.color = hex;
      this.handleMouseDown();
    }
  }
};
</script>

<style scoped>
.segment-color {
  background-color: red;
  width: 12px;
  cursor: pointer;
  height: 100%;

}
.segment-color-context {
  background-color: red;
  width:100%;
  cursor: pointer;
}

.segment-color-holder {
  height: 100%;
  position: relative;
}

.sc-svg {
  width: 12px;
  height: 100%;
}
</style>